import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { FeedContentType, FeedSortOrder } from "@upsquad/shared";
import { logOut } from "@/src/auth/store/auth-slice";

interface FeedState {
	activeSort: FeedSortOrder;
	activeContentType: FeedContentType;
	activeGroupIds: string[];
}

const initialState: FeedState = {
	activeSort: "latest",
	activeContentType: "all",
	activeGroupIds: [],
};

export const postFeedSlice = createSlice({
	name: "feed",
	initialState,
	reducers: {
		setActiveSort: (state, { payload }: PayloadAction<FeedSortOrder>) => {
			state.activeSort = payload;
		},
		setActiveContentType: (state, { payload }: PayloadAction<FeedContentType>) => {
			state.activeContentType = payload;
		},
		setActiveGroupIds: (state, { payload }: PayloadAction<string[]>) => {
			state.activeGroupIds = payload;
		},
		resetFilters: (state) => {
			state.activeSort = "latest";
			state.activeContentType = "all";
			state.activeGroupIds = [];
		},
	},
	extraReducers: (builder) => {
		builder.addCase(logOut, () => initialState);
	},
});

export const { setActiveSort, setActiveContentType, setActiveGroupIds, resetFilters } = postFeedSlice.actions;
